module.exports = __webpack_public_path__ + "ca91ee574785593ae83738c76ffb63ab.svg";